<template>
  <v-container
    class="mt-0 pt-0"
    :style="{ height: 'auto', minHeight: '100%' }"
    fluid
  >
    <v-row class="fill-height mt-1 mx-1">
      <v-col cols="12">
        <template v-if="showSkeleton">
          <v-skeleton-loader
            class="mt-6 mb-6"
            type="card-avatar, article, list-item-avatar, list-item-avatar"
          ></v-skeleton-loader>
        </template>
        <template v-if="!showSkeleton && courseData != null">
          <section>
            <!-- section head -->
            <v-row dense>
              <v-col cols="12">
                <v-card color="#fafafa" flat>
                  <v-row>
                    <v-col xl="4" lg="5" md="5" sm="12" class="my-auto">
                      <v-img
                        :src="courseData.detail.image"
                        class="avatar"
                      ></v-img>
                    </v-col>
                    <v-col xl="8" lg="7" md="7" sm="12" class="my-auto">
                      <v-card-text>
                        <template v-if="firstCategory != null">
                          <p>
                            <span
                              @click="gotoCategory(firstCategory)"
                              class="color-primary pointer"
                            >
                              Category: {{ firstCategory.title }}
                            </span>
                          </p>
                        </template>
                        <template v-else>
                          <p class="color-primary">Category: -</p>
                        </template>
                        <h2 class="mb-4">
                          {{ courseData.detail.title }}
                        </h2>
                        <template v-if="instructor != null">
                          <p>
                            <span
                              class="
                                font-italic
                                body-2
                                pointer
                                grey--text
                                text--darken-1
                              "
                              @click="goToInstructor(instructor._id)"
                            >
                              by {{ instructor.displayName }}
                            </span>
                          </p>
                        </template>
                        <template v-else>
                          <p
                            class="font-italic body-2 grey--text text--darken-1"
                          >
                            by Unknow
                          </p>
                        </template>
                        <div
                          class="body-2"
                          v-html="courseData.detail.description"
                        ></div>
                        <div class="mt-3 py-auto d-flex">
                          <v-rating
                            half-increments
                            half-icon="fas fa-star-half-alt"
                            background-color="grey"
                            color="amber"
                            readonly
                            dense
                            size="18"
                            :value="courseData.detail.rating"
                          ></v-rating>
                          <label
                            class="ml-2 pt-1 text--secondary pointer"
                            @click="gotoReview()"
                          >
                            {{ courseData.detail.rating }} ({{
                              courseData.detail.countComment
                            }}
                            Reviews)
                          </label>
                        </div>
                        <!-- <v-row class="mt-3" v-if="courseData.detail.bought">
                          <v-col cols="12">
                            <v-card-actions class="pa-0">
                              <template
                                v-if="
                                  courseData.detail.bought == false &&
                                  courseData.detail.boughtStatus == 'wait'
                                "
                              >
                                <v-btn
                                  class="font-weight-regular text-md-body-2 text-xl-body-1"
                                  :color="buttonColor"
                                  dark
                                  min-width="130"
                                >
                                  Pending
                                </v-btn>
                              </template>
                              <template
                                v-else-if="
                                  courseData.detail.bought &&
                                  courseData.detail.boughtStatus == 'accept'
                                "
                              >
                                <v-btn
                                  class="font-weight-regular text-md-body-2 text-xl-body-1"
                                  :color="buttonColor"
                                  dark
                                  @click="goToClassRoom"
                                  min-width="130"
                                >
                                  Continue
                                </v-btn>
                              </template>
                              <template v-else>
                                <v-btn
                                  class="font-weight-regular text-md-body-2 text-xl-body-1"
                                  :color="buttonColor"
                                  dark
                                  @click="openEnrollDialog"
                                  :loading="progressEnroll"
                                  min-width="130"
                                >
                                  Enroll
                                </v-btn>
                              </template>

                              <template v-if="courseData.detail.wishList">
                                <v-btn
                                  class="text-capitalize text-md-body-2 text-xl-body-1"
                                  outlined
                                  color="pink"
                                  @click="onWishlist()"
                                >
                                  <v-icon left> mdi-heart </v-icon>
                                  In Favorite
                                </v-btn>
                              </template>
                              <template v-else>
                                <v-btn
                                  class="text-capitalize text-md-body-2 text-xl-body-1"
                                  outlined
                                  @click="onWishlist()"
                                >
                                  <v-icon left> mdi-heart-outline </v-icon>
                                  Add Favorite
                                </v-btn>
                              </template>

                              <v-btn
                                v-if="
                                  courseData.detail.useBoard &&
                                  courseData.detail.bought &&
                                  courseData.detail.boughtStatus == 'accept'
                                "
                                class="text-capitalize text-md-body-2 text-xl-body-1"
                                outlined
                                :to="{
                                  name: 'discussion',
                                  params: { id: courseId },
                                }"
                              >
                                <v-icon left> mdi-comment-processing </v-icon>
                                Discussion Board
                              </v-btn>
                            </v-card-actions>
                          </v-col>
                        </v-row> -->
                        <v-row class="mt-3">
                          <v-col cols="12">
                            <div
                              class="
                                d-flex
                                flex-column flex-md-row
                                align-center
                              "
                            >
                              <template v-if="isOwnedAndAccepted">
                                <div>
                                  <v-btn
                                    class="
                                      font-weight-regular
                                      text-md-body-2 text-xl-body-1
                                    "
                                    :color="buttonColor"
                                    dark
                                    @click="goToClassRoom"
                                    min-width="130"
                                  >
                                    Start course
                                  </v-btn>
                                </div>
                              </template>
                              <template v-else-if="isOwnedAndPending">
                                <div>
                                  <v-btn
                                    class="
                                      font-weight-regular
                                      text-md-body-2 text-xl-body-1
                                    "
                                    :color="buttonColor"
                                    dark
                                    min-width="130"
                                  >
                                    Pending
                                  </v-btn>
                                </div>
                              </template>
                              <template v-else>
                                <template v-if="hasBundles == false">
                                  <div class="flex-grow-1 headline pa-0">
                                    Free
                                  </div>
                                </template>
                                <template
                                  v-else-if="hasBundles && !shouldShowPackage"
                                >
                                  <div class="flex-grow-1 headline pa-0">
                                    ฿{{
                                      courseData.arrayBundles[0].price
                                        | numFormat("0,0.00")
                                    }}
                                    <div class="mt-0">
                                      <bundle-expire-label
                                        :bundle="selectedBundle"
                                      ></bundle-expire-label>
                                    </div>
                                  </div>
                                </template>
                                <template
                                  v-else-if="hasBundles && shouldShowPackage"
                                >
                                  <div class="flex-grow-1 headline pa-0">
                                    <template v-if="selectedBundle == null">
                                      ฿{{ minPrice | numFormat("0,0.00") }} -
                                      ฿{{ maxPrice | numFormat("0,0.00") }}
                                    </template>
                                    <template v-else>
                                      ฿{{
                                        selectedBundle.price
                                          | numFormat("0,0.00")
                                      }}
                                    </template>
                                    <div class="mt-0">
                                      <bundle-expire-label
                                        :bundle="selectedBundle"
                                      ></bundle-expire-label>
                                    </div>
                                  </div>
                                </template>

                                <!-- buy & enroll button -->
                                <div>
                                  <template v-if="hasBundles == false">
                                    <v-btn
                                      class="
                                        font-weight-regular
                                        text-md-body-2 text-xl-body-1
                                      "
                                      :color="buttonColor"
                                      dark
                                      @click="openEnrollDialog"
                                      :loading="progressEnroll"
                                      min-width="130"
                                    >
                                      Enroll
                                    </v-btn>
                                  </template>
                                  <template
                                    v-else-if="hasBundles && !shouldShowPackage"
                                  >
                                    <v-btn
                                      class="
                                        font-weight-regular
                                        text-md-body-2 text-xl-body-1
                                      "
                                      :color="buttonColor"
                                      dark
                                      @click="onBuyBundle"
                                      :disabled="!isPaymentAvailable"
                                      :loading="progressEnroll"
                                      min-width="130"
                                    >
                                      Buy
                                    </v-btn>
                                  </template>
                                  <template v-else>
                                    <v-btn
                                      class="
                                        font-weight-regular
                                        text-md-body-2 text-xl-body-1
                                      "
                                      :color="buttonColor"
                                      @click="onBuyBundle"
                                      :loading="progressEnroll"
                                      min-width="130"
                                      :disabled="
                                        selectedBundle == null ||
                                        !isPaymentAvailable
                                      "
                                    >
                                      <span
                                        :class="{
                                          'white--text': selectedBundle != null,
                                        }"
                                        >Buy</span
                                      >
                                    </v-btn>
                                  </template>
                                </div>
                              </template>

                              <!-- wishlist & discussion board button -->
                              <div class="ml-2">
                                <template v-if="courseData.detail.wishList">
                                  <v-btn
                                    class="
                                      text-capitalize
                                      text-md-body-2
                                      text-xl-body-1
                                    "
                                    outlined
                                    color="pink"
                                    @click="onWishlist()"
                                  >
                                    <v-icon left> mdi-heart </v-icon>
                                    In Favorite
                                  </v-btn>
                                </template>
                                <template v-else>
                                  <v-btn
                                    class="
                                      text-capitalize
                                      text-md-body-2
                                      text-xl-body-1
                                    "
                                    outlined
                                    @click="onWishlist()"
                                  >
                                    <v-icon left> mdi-heart-outline </v-icon>
                                    Add Favorite
                                  </v-btn>
                                </template>
                              </div>
                              <template
                                v-if="
                                  isOwnedAndAccepted &&
                                  courseData.detail.useBoard == true
                                "
                              >
                                <div class="ml-2">
                                  <v-btn
                                    class="
                                      text-capitalize
                                      text-md-body-2
                                      text-xl-body-1
                                    "
                                    outlined
                                    :to="{
                                      name: 'discussion',
                                      params: { id: courseId },
                                    }"
                                  >
                                    <v-icon left>
                                      mdi-comment-processing
                                    </v-icon>
                                    Discussion Board
                                    <!-- <span class="available-app"> (Available on mobile application.)</span> -->
                                  </v-btn>
                                </div>
                              </template>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <template
                v-if="hasBundles && shouldShowPackage && !isOwnedAndAccepted"
              >
                <v-col cols="12">
                  <bundle-list
                    :bundles="courseData.arrayBundles"
                    @onChoose="onChooseBundle"
                  ></bundle-list>
                </v-col>
              </template>
            </v-row>
            <v-row dense class="my-6 row-content">
              <v-col class="column-left-content">
                <!-- section detail course -->
                <div>
                  <v-expansion-panels accordion multiple v-model="panel">
                    <v-expansion-panel
                      v-for="(section, i) of dataSection"
                      :key="`section_${i}`"
                    >
                      <v-expansion-panel-header color="#f2f2f2">
                        <template v-slot:actions>
                          <v-icon class="icon mr-3">mdi-chevron-up</v-icon>
                        </template>
                        <div class="header body-1 font-weight-regular">
                          {{ section.title }}
                        </div>
                        <div class="name text-right">
                          <span
                            class="caption pointer"
                            @click="goToInstructor(section._id)"
                          >
                            {{ section.displayName }}
                          </span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-3">
                        <template v-for="(lecture, j) of section.lectures">
                          <v-row :key="`lecture_${section._id}_${j}`">
                            <v-col xl="6" lg="10" md="10" sm="8" cols="12">
                              <v-row
                                @click="checkGoToClassRoom"
                                :class="{
                                  cursorPointerRow: isOwnedAndAccepted,
                                }"
                              >
                                <v-col cols="2" xl="1" lg="1" md="1" sm="1">
                                  <v-icon class="ml-1">{{
                                    lecture.type | courseSectionTypeIcon
                                  }}</v-icon>
                                </v-col>
                                <v-col
                                  cols="10"
                                  xl="11"
                                  lg="11"
                                  md="11"
                                  sm="11"
                                  class="py-4"
                                >
                                  <span class="body-2">{{
                                    lecture.title
                                  }}</span>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </template>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
                <!-- section student feedback -->
                <div class="my-6">
                  <v-card flat outlined>
                    <v-card-title class="px-5"
                      ><h4>Student feedback</h4></v-card-title
                    >
                    <v-row class="mx-2 mb-2" no-gutters>
                      <v-col
                        cols="12"
                        sm="4"
                        md="4"
                        lg="4"
                        xl="3"
                        class="text-center my-auto"
                      >
                        <div class="text-course-rating">
                          {{ courseData.detail.rating }}
                        </div>
                        <div class="my-1">
                          <v-rating
                            half-increments
                            half-icon="fas fa-star-half-alt"
                            background-color="grey"
                            color="amber"
                            dense
                            :value="courseData.detail.rating"
                            size="18"
                            readonly
                          ></v-rating>
                        </div>
                        <h2 class="font-weight-regular my-1 grey--text">
                          Course Rating
                        </h2>
                      </v-col>
                      <v-col cols="12" sm="8" md="8" lg="8" xl="9">
                        <v-list flat disabled>
                          <v-list-item-group>
                            <v-list-item
                              v-for="(item, i) in itemFeedBack"
                              :key="i"
                            >
                              <v-list-item-icon class="my-1">
                                <v-icon size="20">mdi-star</v-icon>
                                <div class="subtitle-1 ml-1 mt-1">
                                  {{ item.rating }}
                                </div>
                              </v-list-item-icon>
                              <v-list-item-content class="pr-2">
                                <v-list-item-title>
                                  <v-progress-linear
                                    height="8"
                                    :color="
                                      item.percent.toFixed() != 0
                                        ? 'amber'
                                        : 'amber lighten-4'
                                    "
                                    :value="
                                      item.percent.toFixed() != 0
                                        ? item.percent.toFixed()
                                        : 100
                                    "
                                    rounded
                                  >
                                  </v-progress-linear>
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <span class="subtitle-2">{{
                                  item.percent.toFixed() + "%"
                                }}</span>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
                <!-- section comment -->
                <div class="my-6">
                  <v-card flat outlined id="reviews-section">
                    <v-row class="mx-2 mt-2">
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                        xl="6"
                        class="reviews px-4"
                      >
                        <h2>Reviews</h2>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="6"
                        lg="6"
                        xl="6"
                        class="btn-reviews"
                      >
                        <template>
                          <template
                            v-if="
                              courseData.comment.filter(
                                (comment) =>
                                  comment.owner_by_students._id == myId
                              ).length <= 0
                            "
                          >
                            <v-btn
                              dark
                              :color="buttonColor"
                              class="font-weight-regular text-capitalize"
                              @click="showFormComment(null)"
                            >
                              <v-icon left dark> mdi-pencil-box-outline </v-icon
                              >Write Review
                            </v-btn>
                          </template>
                        </template>
                      </v-col>
                    </v-row>
                    <template
                      v-if="
                        courseData.comment == null ||
                        courseData.comment.length == 0
                      "
                    >
                      <v-alert class="ma-5" dense text type="info"
                        >Not have reviews</v-alert
                      >
                    </template>
                    <template v-for="item in commentItems">
                      <v-list-item :key="item.title">
                        <v-list-item-avatar class="mb-auto">
                          <v-img :src="item.owner_by_students.image"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="my-1">
                            <h4>{{ item.owner_by_students.displayName }}</h4>
                          </v-list-item-title>
                          <v-list-item-subtitle class="my-2">
                            <v-rating
                              half-increments
                              half-icon="fas fa-star-half-alt"
                              background-color="grey"
                              color="amber"
                              readonly
                              dense
                              small
                              :value="item.rating"
                            ></v-rating>
                            <span class="ml-5">{{
                              item.created_at | moment("from", "now")
                            }}</span>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="my-2 body-2 text-wrap">
                            {{ item.text }}
                          </v-list-item-subtitle>
                          <template v-if="item.owner_by_students._id == myId">
                            <v-list-item-subtitle class="my-2 body-2 text-wrap">
                              <a
                                @click="showFormComment(item)"
                                class="anchor-no-decoration caption"
                                >Edit
                              </a>
                            </v-list-item-subtitle>
                          </template>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <div
                      class="my-3 text-center"
                      v-if="
                        courseData.comment !== null &&
                        courseData.comment.length > 0
                      "
                    >
                      <v-btn
                        v-if="courseData.comment.length > default_limit"
                        class="mb-3 text-capitalize"
                        outlined
                        color="#9b9b9b"
                        @click="simpleToggleShowMore(courseData.comment.length)"
                        >{{
                          limit_by === default_limit ? "show more" : "show less"
                        }}</v-btn
                      >
                    </div>
                  </v-card>
                </div>
              </v-col>
              <!-- section right -->
              <v-col class="column-right-content">
                <!-- certificated -->
                <v-card
                  flat
                  outlined
                  class="mb-8 pa-3"
                  v-if="
                    courseData.detail.bought &&
                    courseData.detail.boughtStatus == 'accept' &&
                    courseData.detail.certificate == true
                  "
                >
                  <v-card-title><h5>Accomplishment</h5></v-card-title>
                  <v-card-subtitle>
                    <p>
                      เงื่อนไขในการบรรลุเป้าหมายคุณต้องเรียนให้ครบ
                      {{ courseData.percentCertificate }}% ขึ้นไปถึงจะได้รับใบ
                      Certificate
                    </p>
                    <div>
                      <div>
                        <span>Success</span>
                        <div class="float-right">
                          {{ courseData.percentHistory }} %
                        </div>
                      </div>
                      <v-progress-linear
                        :value="courseData.percentHistory"
                        background-color="grey lighten-4"
                        :color="courseData.navBarTitle.themeColor"
                        rounded
                        height="10"
                        reactive
                      >
                      </v-progress-linear>
                    </div>
                  </v-card-subtitle>
                  <v-card-text>
                    <v-sheet
                      v-if="
                        courseData.urlCertificate &&
                        courseData.percentHistory >=
                          courseData.percentCertificate
                      "
                      color="grey lighten-3"
                      class="mt-5 pa-5"
                    >
                      <v-row justify="center">
                        <v-col cols="12" class="text-center">
                          <div
                            class="py-3 title font-weight-bold"
                            :style="{
                              color: courseData.navBarTitle.themeColor,
                            }"
                          >
                            ยินดีด้วย
                          </div>
                          <p class="subtitle-1 body-1">
                            คุณเรียนครบตามเป้าหมายแล้ว
                          </p>
                          <v-img
                            :src="courseData.detail.urlCertificate"
                            aspect-ratio="1.7"
                            contain
                          ></v-img>
                          <v-btn
                            :color="buttonColor"
                            class="my-3 text-capitalize"
                            outlined
                            tile
                            @click="downloadCertificate"
                          >
                            <v-icon left> mdi-eye </v-icon>
                            View
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-sheet>
                  </v-card-text>
                </v-card>
                <!-- contents -->
                <v-card flat outlined class="pa-3">
                  <v-card-text>
                    <template v-if="courseData.detail.countType != null">
                      <v-list class="pt-0">
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon class="fa-fw">{{
                              "VDO" | courseSectionTypeIcon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="subtitle-1">
                              {{ courseData.detail.countType.video }} Video(s)
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon class="fa-fw">{{
                              "BOOK" | courseSectionTypeIcon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="subtitle-1"
                              >{{
                                courseData.detail.countType.book
                              }}
                              Book(s)</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon class="fa-fw">{{
                              "BLOG" | courseSectionTypeIcon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="subtitle-1"
                              >{{
                                courseData.detail.countType.blog
                              }}
                              Blog(s)</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon class="fa-fw">{{
                              "IMG" | courseSectionTypeIcon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="subtitle-1"
                              >{{
                                courseData.detail.countType.image
                              }}
                              Picture(s)</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon class="fa-fw">{{
                              "PDF" | courseSectionTypeIcon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="subtitle-1"
                              >{{
                                courseData.detail.countType.pdf
                              }}
                              PDF(s)</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon class="fa-fw">{{
                              "FILE" | courseSectionTypeIcon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="subtitle-1"
                              >{{
                                courseData.detail.countType.file
                              }}
                              File(s)</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-icon>
                            <v-icon class="fa-fw">{{
                              "EXAM" | courseSectionTypeIcon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="subtitle-1"
                              >{{
                                courseData.detail.countType.exam
                              }}
                              Exam(s)</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </template>
                  </v-card-text>
                </v-card>
                <!-- skills/tags -->
                <v-card flat outlined class="py-3" color="#fafafa">
                  <v-card-title><h5>Tags</h5></v-card-title>
                  <v-card-text>
                    <v-chip-group column>
                      <template v-for="item in courseData.detail.skills">
                        <v-chip
                          :key="item._id"
                          @click="gotoTag(item)"
                          :value="item._id"
                        >
                          <span class="title-tag">{{ item.title }}</span>
                        </v-chip>
                      </template>
                    </v-chip-group></v-card-text
                  >
                </v-card>
                <!-- grade -->
                <v-card
                  flat
                  outlined
                  class="py-3"
                  color="#fafafa"
                  v-if="courseData.detail.grades.length > 0"
                >
                  <v-card-title><h5>Grade</h5></v-card-title>
                  <v-card-text>
                    <v-list color="#fafafa">
                      <v-list-item-group>
                        <v-list-item
                          v-for="(item, i) in courseData.detail.grades"
                          :key="i"
                        >
                          <v-list-item-icon class="mr-2">
                            <v-icon color="grey lighten-1" x-small
                              >mdi-circle</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content @click="gotoGrade(item)">
                            <v-list-item-title>{{
                              item.title
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <!-- write review dialog -->
            <v-dialog v-model="reviewsDialog" persistent max-width="700">
              <v-card>
                <v-card-title class="subtitle-1"> Write Review </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <div class="mt-5">
                    <template v-if="errSaveComment">
                      <v-alert type="error" outlined class="ma-4"
                        >Can not save comment</v-alert
                      >
                    </template>
                    <v-rating
                      v-model="rating"
                      half-increments
                      half-icon="fas fa-star-half-alt"
                      background-color="grey"
                      color="amber"
                      dense
                      size="25"
                    ></v-rating>
                  </div>
                  <div class="mt-5">
                    <v-textarea
                      v-model="comment"
                      outlined
                      placeholder="Write a comment here..."
                      color="grey lighten-2"
                      hide-details
                    >
                    </v-textarea>
                  </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-2 px-5">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="text-capitalize font-weight-regular"
                    outlined
                    text
                    @click="reviewsDialog = false"
                    width="90"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    class="text-capitalize font-weight-regular"
                    :color="buttonColor"
                    dark
                    @click="writeComment"
                    :loading="progressSaveComment"
                    width="100"
                  >
                    Submit
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </section>
        </template>
      </v-col>
    </v-row>

    <payment-dialog
      ref="paymentDialog"
      @onSuccess="onSuccessPayment"
    ></payment-dialog>

    <EnrollDialogChooseRoom />
  </v-container>
</template> 
<script>
function compare(a, b) {
  if (a.price < b.price) {
    return -1;
  }
  if (a.price > b.price) {
    return 1;
  }
  return 0;
}
import Vue from "vue";
import { EventBus } from "@/event-bus";
import EnrollDialogChooseRoom from "@/components/EnrollDialogChooseRoom.vue";
import PaymentDialog from "../components/PaymentDialog";
import BundleList from "../components/BundleList";
import BundleExpireLabel from "../components/BundleExpireLabel";
export default {
  name: "course_detail",
  components: {
    EnrollDialogChooseRoom,
    PaymentDialog,
    BundleList,
    BundleExpireLabel,
  },
  data: () => ({
    progressWishlist: false,
    progressEnroll: false,
    loading: false,
    courseData: null,
    showSkeleton: true,
    latestSection: 0,
    rating: 5,
    comment: "",
    parentComment: null,
    formComment: false,
    progressSaveComment: false,
    errSaveComment: false,
    rooms: [],
    dataSection: [],
    courseDetail: [],
    reviewsDialog: false,
    default_limit: 3,
    limit_by: 3,
    itemFeedBack: [],
    panel: [0],
    selectedBundle: null,
  }),
  computed: {
    isPaymentAvailable() {
      let val = this.$store.state.paymentAvailable;
      if (val == null) {
        val = false;
      }
      return val;
    },
    minPrice() {
      const min = this.courseData.arrayBundles.reduce(function (prev, current) {
        return prev.price < current.price ? prev : current;
      });
      return min.price;
    },
    maxPrice() {
      const max = this.courseData.arrayBundles.reduce(function (prev, current) {
        return prev.price > current.price ? prev : current;
      });
      return max.price;
    },
    isOwnedAndPending() {
      if (
        this.courseData != null &&
        this.courseData.detail.bought == false &&
        this.courseData.detail.boughtStatus == "wait"
      ) {
        return true;
      }
      return false;
    },
    isOwnedAndAccepted() {
      if (
        this.courseData != null &&
        this.courseData.detail.bought == true &&
        this.courseData.detail.boughtStatus == "accept"
      ) {
        return true;
      }
      return false;
    },
    commentItems() {
      if (this.courseData != null) {
        return this.courseData.comment.slice(0, this.limit_by);
      }
      return [];
    },
    shouldShowPackage() {
      if (
        this.courseData.arrayBundles != null &&
        this.courseData.arrayBundles.length > 1
      ) {
        return true;
      }
      return false;
    },
    hasBundles() {
      if (
        this.courseData.arrayBundles != null &&
        this.courseData.arrayBundles.length > 0
      ) {
        return true;
      }
      return false;
    },
    buttonColor() {
      return Vue.prototype.$userInfo.companies[0].buttonColor;
    },
    myId() {
      return Vue.prototype.$userInfo._id;
    },
    instructor() {
      this.courseDetail = this.courseData.detail.sections;
      this.fetchSection();
      if (
        this.courseData.detail.owner_by_students != null &&
        this.courseData.detail.owner_by_students.length > 0
      ) {
        return this.courseData.detail.owner_by_students[0]._id;
      }
      return null;
    },
    instructors() {
      if (
        this.courseData.detail.owner_by_students != null &&
        this.courseData.detail.owner_by_students.length > 0
      ) {
        return this.courseData.detail.owner_by_students;
      }
      return [];
    },
    commentable() {
      return true;
    },
    courseId() {
      return this.$route.params.id;
    },
    firstCategory() {
      if (this.courseData != null) {
        return this.courseData.detail.categories[0];
      }

      return null;
    },
  },
  beforeDestroy() {
    EventBus.$off("enroll");
    EventBus.$off("wishlist");
  },
  async mounted() {
    EventBus.$on("enroll", (idroom) => {
      this.onEnroll(idroom);
    });
    EventBus.$on("wishlist", () => {
      this.onWishlist();
    });
    await this.init();
    this.studentFeedback();
    this.fetchBundle();
  },
  methods: {
    onBuyBundle() {
      let token = this.$cookies.get("user_token");
      if (token) {
        this.$refs.paymentDialog.open({
          bundleId: this.selectedBundle._id,
          price: this.selectedBundle.price,
        });
      } else {
        this.$router.replace({ name: "login" });
      }
    },
    onSuccessPayment(resp) {
      // console.log(resp);
      this.$refs.paymentDialog.close();
      // show success dialog
      this.init();
      this.studentFeedback();
      this.fetchBundle();
      this.selectedBundle = null;
    },
    onChooseBundle(bundle) {
      console.log(bundle);
      this.selectedBundle = bundle;
      // this.$refs.paymentDialog.open({
      //   bundleId: bundle._id,
      //   price: bundle.price,
      // });
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    fetchBundle() {
      var sortable = [];
      if (this.courseData.arrayBundles.length) {
        sortable = this.courseData.arrayBundles.sort(compare);
      } else {
      }
      // check set default price after fetch bundle
      if (this.hasBundles && !this.shouldShowPackage) {
        this.selectedBundle = sortable[0];
      }
      console.log(sortable);
    },
    downloadCertificate() {
      // let routeData = this.$router.resolve({name: 'routeName', query: {data: this.courseData.detail.urlCertificate}});
      window.open(this.courseData.detail.urlCertificate, "_blank");
    },
    fetchSection() {
      this.dataSection = [];
      this.courseDetail.forEach((section) => {
        this.dataSection.push({
          lectures: section.lectures,
          priority: section.priority,
          title: section.title,
          id: section._id,
          ...section.teacher,
        });
      });
      console.log(this.dataSection);
    },
    goToClassRoom() {
      this.$router.push({
        name: "classroom",
        params: {
          id: this.courseData.detail._id,
        },
      });
    },
    checkGoToClassRoom() {
      if (this.isOwnedAndAccepted) {
        this.$router.push({
          name: "classroom",
          params: {
            id: this.courseData.detail._id,
          },
        });
      }
    },
    openEnrollDialog() {
      EventBus.$emit("openEnrollDialog", true);
    },
    onEnroll(idroom) {
      if (!this.progressEnroll) {
        this.progressEnroll = true;
        let params = {
          idcourse: this.courseId,
          idroom,
        };

        // if(this.courseData.detail.prices.lengh > 0 && this.courseData.detail.prices[0].){
        //   params = {
        //     ...params,
        //     idprice: this.courseData.detail.prices[0]._
        //   }
        // }

        this.$http
          .post(`${this.$store.state.api}/mylib/request`, params)
          .then((resp) => {
            if (resp.status == 200 && resp.data.status) {
              this.init();
            } else {
              // notify error
            }
          })
          .catch((err) => {})
          .finally(() => {
            this.progressEnroll = false;
          });
      }
    },
    onWishlist() {
      this.progressWishlist = true;
      let params = {
        idcourse: this.courseId,
      };
      this.$http
        .put(`${this.$store.state.api}/wishlist/manage/course`, params)
        .then((resp) => {
          if (resp.status == 200 && resp.data.status) {
            this.init();
          } else {
            // notify error
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.progressWishlist = false;
        });
    },
    writeComment() {
      this.reviewsDialog = false;
      this.progressSaveComment = true;
      let params = {
        text: this.comment,
        courses: this.$route.params.id,
        rating: this.rating,
        idcomment: this.parentComment == null ? "" : this.parentComment,
      };
      this.$http
        .post(`${this.$store.state.api}/comment/manage/insert`, params)
        .then((resp) => {
          if (resp.data.status == true) {
            this.errSaveComment = false;
            this.formComment = false;
            this.init();
          } else {
            this.errSaveComment = true;
          }
        })
        .catch((err) => {
          this.errSaveComment = true;
        })
        .finally(() => {
          this.progressSaveComment = false;
        });
    },
    showFormComment(review) {
      this.reviewsDialog = true;
      this.comment = "";
      this.rating = 5;
      this.parentComment = null;
      if (review != null) {
        // this.parentComment = review._id;
        this.comment = review.text;
        this.rating = review.rating;
      }
      this.formComment = true;
      this.$nextTick(() => {
        this.$vuetify.goTo("#commentEditor");
      });
    },
    goToInstructor(id) {
      this.$router.push({
        name: "instructor",
        params: {
          id: id,
        },
      });
    },
    gotoCategory(item) {
      this.$router.push({
        name: "course",
        query: {
          category: item._id,
          page: 1,
          limit: 10,
          sort: "created_at",
          sortBy: -1,
          title: item.title,
        },
      });
    },
    gotoReview() {
      this.$vuetify.goTo("#reviews-section");
    },
    goToClassRoom() {
      this.$router.push({
        name: "classroom",
        params: {
          id: this.courseData.detail._id,
        },
      });
    },
    gotoTag(item) {
      this.$router.push({
        name: "course",
        query: {
          skill: item._id,
          page: 1,
          limit: 10,
          sort: "created_at",
          sortBy: -1,
          title: item.title,
        },
      });
    },
    gotoGrade(item) {
      this.$router.push({
        name: "course",
        query: {
          grade: item._id,
          page: 1,
          limit: 10,
          sort: "created_at",
          sortBy: -1,
        },
      });
    },
    simpleToggleShowMore(item_length) {
      this.limit_by =
        this.limit_by === this.default_limit ? item_length : this.default_limit;
    },
    hasHours(duration) {
      return this.$moment.duration(duration).get("hours") > 0 ? true : false;
    },
    async init() {
      await this.fetch()
        .then((resp) => {
          if (resp.status == 200 && resp.data.status) {
            this.courseData = resp.data.result;
            this.$store.commit("setCourseImage", data.data.result.image);
          } else {
            this.courseData = null;
          }
        })
        .catch((err) => {})
        .finally(() => {
          this.showSkeleton = false;
        });
      await this.studentFeedback();
    },
    fetch() {
      return this.$http.get(
        `${this.$store.state.api}/course/detail?id=${this.courseId}`
      );
    },
    studentFeedback() {
      //สูตร จำนวนคนที่ให้ดาวแต่ละเลข * 100 / จำนวนคนทั้งหมด
      this.itemFeedBack = [];
      for (let index = 5; index >= 1; index--) {
        let rating = index;
        let total = 0;
        let allComment = this.courseData.comment.length;
        let items = this.courseData.comment.filter(
          (comment) => comment.rating >= index && comment.rating < index + 1
        );
        if (items.length > 0) {
          total = items.length;
        }
        this.itemFeedBack.push({
          rating: index,
          total: total,
          percent: (total * 100) / allComment ? (total * 100) / allComment : 0,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.column-left-content {
  flex: 0 0 60%;
  max-width: 60%;
}
.column-right-content {
  flex: 0 0 40%;
  max-width: 40%;
}
.v-expansion-panels--tile ::v-deep .v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panels {
  border: 1px solid #e3e3e3;
}
.description-title {
  font-weight: 400 !important;
}
.write-btn {
  width: 192px;
  min-width: 192px !important;
}
.white-text {
  color: "white";
}
.v-rating {
  display: inline-block;
}
.color-primary {
  color: #009bde;
}
.avatar {
  max-height: 300px;
}
.icon {
  order: 0;
}
.header {
  order: 1;
}
.name {
  order: 2;
}
.head-content .v-btn {
  width: 100%;
}
.btn-reviews {
  text-align: right;
}
.text-course-rating {
  font-size: 3.75rem;
}
.v-expansion-panel::before {
  box-shadow: none !important;
}
.pointer {
  cursor: pointer;
}
@media only screen and (max-width: 480px) {
  .btn-reviews,
  .reviews {
    text-align: center;
  }
}
@media only screen and (max-width: 768px) {
  .column-left-content {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .column-right-content {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .avatar {
    max-height: 350px;
  }
  .row-content {
    flex-direction: column-reverse;
  }
}
@media only screen and (min-width: 1024px) {
  .column-right-content div.v-card {
    margin-left: 28px;
  }
  .text-course-rating {
    font-size: 4.75rem;
  }
}
@media only screen and (min-width: 1796px) {
  .avatar {
    max-height: 260px;
  }
  .column-left-content {
    flex: 0 0 65%;
    max-width: 65%;
  }
  .column-right-content {
    flex: 0 0 35%;
    max-width: 35%;
  }
  .text-course-rating {
    font-size: 5.75rem;
  }
}
.available-app {
  font-size: 12px;
}
.cursorPointerRow {
  cursor: pointer;
}
</style>
